import inView from 'in-view/dist/in-view.min.js'
import  {readCookie} from './cookie.js'

let withAnimations = false;

(function( $ ) {
  $.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();

    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $('.content p, .content > h1, .content > h2, .content > h3, .content > img').each(function(){
    $(this).addClass('animate from-top');
  });

  $('.content li').each(function(){
    $(this).addClass('animate from-left');
  });

  $('.content .wp-block-gallery .blocks-gallery-item').addClass('with_animations');

  $('.wp-block-gallery figure').each(function(){
    $(this).addClass('animate from-top');
  });

  if ($('.with_animations').length > 0) {
    withAnimations = true;
    $('.with_animations').each(function(){
      let delay = 0.15;
      let i = 0;
      $(this).children('.animate').each(function(){
          $(this).css('animation-delay',i+'s');
          i = i + delay;
      });
      $(this).find('.wpcf7-form').find('.animate').each(function(){
          $(this).css('animation-delay',i+'s');
          i = i + delay;
      });
    });
  }
//}

  let loaded = true;

  $(window).load(function(){
    let time = 3800;
    if (readCookie('visited') == 'visited0') {
      time = 10;
    }
    $('.with_animations').each(function(){
      if ($(this).isInViewport()) {
        let that = $(this)
        setTimeout(function(){
          that.children('.animate').addClass('animate_start');
          that.find('.wpcf7-form').children('.animate').addClass('animate_start');
          that.find('.post').find('.filtered').addClass('animate_start');
          loaded = true;
        }, time);  
      } else {
        loaded = true;
      }
    });
    //galleries()  
  });

  inView('.animate').on('enter', el => {
    if (withAnimations && loaded) {
      [].map.call(el.querySelectorAll('.animate'), function(element) {
        element.classList.add('animate_start')
      });
      el.classList.add('animate_start')
    }
  });

  // animate clients

  $('.clients-logotypes .column').hover(function(){
    $('.clients-logotypes .column').addClass('transparent')
  }, function () {
    $('.clients-logotypes .column').removeClass('transparent')
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/animate.js